import { BookingCardSeatingAreaButton } from 'components/business/search/booking-card/BookingCardSeatingAreaButton';
import { Dialog, DialogContent, DialogHeading, Divider, Typography } from 'omakase';
import { DialogVariant } from 'omakase/Dialog/DialogCore';
import { FC } from 'react';
import { LocalDateTime } from 'js-joda';
import { ReservationMetadataList } from 'components/business/reservation/ReservationMetadataList';
import { consumer, core } from '@tock/coretypes';

interface AvailabilitySearchResultSeatingAreaDialogProps {
  business: consumer.IBusinessConfig;
  dateTimeValue: LocalDateTime;
  isOpen: boolean;
  lockedSeatingArea?: core.SeatingArea;
  offering: consumer.Offering;
  onClose(): void;
  onSelectSeatingArea(seatingAreaId: number): void;
  partySize: number;
  seatingAreas: core.SeatingArea[];
  variant?: DialogVariant;
}

export const AvailabilitySearchResultSeatingAreaDialog: FC<
  AvailabilitySearchResultSeatingAreaDialogProps
> = ({
  business,
  dateTimeValue,
  isOpen,
  lockedSeatingArea,
  offering,
  onClose,
  onSelectSeatingArea,
  partySize,
  seatingAreas,
  variant,
}) => {
  const getStyleForButton = (id: number) => {
    if (lockedSeatingArea?.id === id) {
      return 'success';
    }
    return 'primary';
  };

  return (
    <Dialog
      variant={variant}
      aria-labelledby="search-results-choose-seating-area-title"
      aria-describedby="search-results-choose-seating-area-description"
      open={isOpen}
      onClose={onClose}
      data-testid="search-results-choose-seating-area"
    >
      <DialogHeading id="search-results-choose-seating-area-title" onClose={onClose}>
        Select a seating option
      </DialogHeading>
      <DialogContent id="search-results-choose-seating-area-description">
        <Typography variant="body01Strong">{business.name}</Typography>
        <Typography mb={2}>{offering.name}</Typography>
        <ReservationMetadataList
          showDateAndTime
          showQuantity
          dateTime={dateTimeValue}
          purchaseCount={partySize}
        />
        <Divider mt={3} mb={3} />
        <Typography variant="body02Strong" mb={2}>
          Available options
        </Typography>
        <ul>
          {seatingAreas.map((sa) => (
            <li key={sa.id}>
              <BookingCardSeatingAreaButton
                buttonVariant={getStyleForButton(sa.id)}
                onClick={() => {
                  if (sa.id) {
                    onSelectSeatingArea(sa.id);
                  }
                }}
                seatingArea={sa}
              >
                <span>{sa.name ?? ''}</span>
              </BookingCardSeatingAreaButton>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
};
